varying vec2 vUv;
uniform sampler2D uPerlin;
uniform sampler2D uVornoi;
uniform float uTime;


void main() {

  //Flow
  vec2 flowUv = vUv;
  flowUv.y -= uTime * 0.2;
  flowUv *= 10.0;
  flowUv.x /= 7.0;
  float flowTexture = texture2D(uPerlin, flowUv).r;
  float flow = flowTexture;
  flow = 0.75 - step(0.35, flow);


  //fallingArea
  vec2 fallingTextureUv = vUv;
  fallingTextureUv.y -= uTime * 0.3;
  fallingTextureUv.x *= 4.0;
  float fallingPerlin = texture2D(uPerlin, fallingTextureUv).r;

  vec2 fallingUv = vUv;
  fallingUv.x -= 0.05;
  fallingUv -= 0.5;
  fallingUv.y += 0.1;
  float fallingArea = 1.0 - distance(vec2(0.0,fallingPerlin * 0.1), fallingUv) * 3.0;
  fallingArea = step(0.4, fallingArea);

  //ripple
  vec2 rippleUv = vUv;
  rippleUv *= 1.2;
  rippleUv.x -= 0.14;
  rippleUv -= 0.5;
  float ripple = distance(vec2(0.0), rippleUv);

  vec2 rippleTextureUv = vUv;
  rippleTextureUv -= 0.5;
  float ripplePerlin = texture2D(uPerlin, rippleTextureUv).r;

  float rippleFade = (1.0 - ripple) - 0.5;
  rippleFade *= 2.0;
  rippleFade += 0.5;

  ripple -= uTime * 0.12;
  ripple = mod((ripple - ripplePerlin * 0.025) * 30.0, 1.0);
  float rippleStrock = 0.7 + ripplePerlin * 0.45;
  rippleStrock = 1.0 - pow(rippleStrock , 2.145);
  ripple = 1.0 - step(rippleStrock, ripple);
  ripple *= clamp(rippleFade,0.0, 1.0);
  ripple = rippleFade * ripple;

  
  vec3 color = vec3(fallingArea);
  vec3 colorOne = vec3(0.1882, 0.5451, 0.7216);
  vec3 colorTwo = vec3(0.5843, 0.7765, 0.8627);

  color = mix(colorOne, colorTwo, fallingArea);
  color = mix(color, colorTwo , flow);
  color = mix(color, colorTwo, ripple);


  gl_FragColor = vec4(color,1.0);
}